module.exports = __webpack_public_path__ + "static/media/dge1.png.a8b51a2d.jpg";